import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Drawer from '@material-ui/core/Drawer';
import Button from 'components/Button';
import SearchBar from 'components/SearchBar';
import COLORS from 'shared/constants/colors';
import AppBar from '@material-ui/core/AppBar';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import ArtworksLibraryItem from 'components/ArtWork/ArtworksLibraryItem';
import { makeStyles } from '@material-ui/core/styles';
import {
  getDesigns,
  clearArtWork,
  getPreDesigns,
  getPhraseDesigns,
  getPlusArtFiles,
  searchBOTDesigns,
} from 'actions/designer';
import Select from 'components/Select';
import ShirtlyPreDesignedDisclaimer from 'components/ArtWork/ShirtlyPreDesignedDisclaimer';
import ProcedureDialog from 'components/ArtWork/ProcedureDialog';
import {
  Container,
  Header,
  CloseIconStyle,
  SearchWrapper,
  ArtworksLibrary,
  Procedure,
  ShirtlyCharges,
} from 'styles/components/ArtWork/browseLibrary';

const buttonRow = {
  justifyContent: 'space-between',
  display: 'flex',
  gridGap: 10,
  flexDirection: 'row',
};

const buttonStyles = {
  color: '#2280c1',
  textAlign: 'right',
  fontSize: 18,
  textDecoration: 'underline',
  cursor: 'pointer',
};

const options = [
  '4th of July',
  'Aprons',
  'Autism',
  'Baby',
  'Baseball',
  'Beer',
  'Breast Cancer',
  'Camping',
  'Canada Day',
  'Christmas',
  'Dog Shirts',
  'Easter',
  'Family Fun',
  'Fathers Day',
  'Mothers Day',
  'Football',
  'Gay Pride',
  'Costume',
  'Fun',
  'Pregnancy Halloween',
  'Hanukkah',
  'I am a Proud',
  'Matching Sets',
  'Maternity',
  'New Random',
  'Pregnancy',
  'St Patricks',
  'Thanksgiving',
  'This Guy',
  'Tote Bags',
  'Valentines',
  'Variation',
  'Wedding',
  'What Makes Me Happy',
  'Whats Your Super Power',
  'Workout',
  'World Cup',
  'Aged and Fabulous',
  'Awesome Since',
  'Born in aging finner than wine',
  'Born To Care',
  'Born To Ride',
  'Cheers and Beers',
  'Classic Gamer',
  'Damn I make look so good',
  'Dont be Jealous',
  'Dont be Jealous I look so good',
  'Family',
  'Growing Old is Mandatory',
  'Grump Old Football Fan',
  'Grumpy Old Man Club',
  'Hello Birthday',
  'Hunting and Fishing Legend',
];

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div hidden={value !== index} {...other}>
      {value === index && children}
    </div>
  );
};

const useStyles = makeStyles({
  root: () => ({
    '& .MuiTab-textColorPrimary.Mui-selected': {
      color: '#000',
    },
    '& .MuiTabs-indicator': {
      backgroundColor: '#000',
    },
    '& .MuiTab-wrapper': {
      fontWeight: '600',
    },
  }),
});

const BrowseLibraryDrawer = ({
  open,
  toggle,
  onDrop,
  orderLine,
  email,
  viewOnly = false,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [search, setSearch] = useState(undefined);
  const [libraryFiles, setLibraryFiles] = useState(undefined);
  const [plusLibraryFiles, setPlusLibraryFiles] = useState(undefined);
  const [preLibraryFiles, setPreLibraryFiles] = useState(undefined);
  const [phrasesFiles, setPhrasesFiles] = useState(undefined);
  const [disclaimerModal, setDisclaimerModal] = useState(false);
  const [procedureModal, setProcedureModal] = useState(false);
  const [selectedTag, setTag] = useState(undefined);
  const emailid = useSelector((state) => state?.auth?.profile?.emailid);
  const [selectedTab, setSelectedTab] = useState(0);
  const [goBarDownEmail, setGoBardownAdmin] = useState('support@gobardown.com');
  const isGobardownSupport = emailid === 'support@gobardown.com';

  const handleTabChange = async (event, newValue) => {
    // if (newValue === 1) {
    //   setDisclaimerModal(true);
    // } else if (newValue == 0) {
    //   setTag(undefined);
    //   setPreLibraryFiles(undefined);
    // } else {
    //   const data = await dispatch(getPhraseDesigns());
    //   setPhrasesFiles({
    //     ...data,
    //     cursors: data?.next_cursor ? [undefined, data?.next_cursor] : [],
    //   });
    // }
    if (newValue == 0) {
      setTag(undefined);
      setPreLibraryFiles(undefined);
    } else if (newValue == 1) {
      const library = await dispatch(
        getPlusArtFiles({
          user: email || emailid,
        })
      );
      if (library.error) {
        return;
      }
      populateLibraryData(library);
      setPlusLibraryFiles({
        ...library,
        cursors: library?.next_cursor ? [undefined, library?.next_cursor] : [],
      });
    }
    setSelectedTab(newValue);
  };

  const searchArtFilesByText = async (
    searchString,
    clearSearchValue = false
  ) => {
    const library = await dispatch(
      searchBOTDesigns({
        user: goBarDownEmail || emailid,
        searchString,
        folder: selectedTab === 0 ? 'ArtFiles' : 'PlusArtFiles',
      })
    );

    if (library.error) {
      return;
    }

    populateLibraryData(library);

    const payload = {
      ...library,
      cursors: library?.next_cursor ? [undefined, library?.next_cursor] : [],
    };

    if (selectedTab === 0) {
      setLibraryFiles(payload);
    } else if (selectedTab === 2) {
      setPlusLibraryFiles(payload);
    }

    if (clearSearchValue) setSearch(searchString);
  };

  const populateLibraryData = (library) => {
    for (let i = 0; i < library?.resources?.length; i++) {
      const l = library?.resources[i];
      const secureUrl = l.secure_url;
      const splitSecureUrl = secureUrl.split('/');
      if (!!splitSecureUrl?.length) {
        l.name = splitSecureUrl[splitSecureUrl?.length - 1];
      }
    }
  };

  useEffect(() => {
    const loadLibrary = async () => {
      if (!libraryFiles) {
        const library = await dispatch(
          getDesigns({
            user: email || emailid,
          })
        );
        if (library.error) {
          return;
        }
        populateLibraryData(library);
        setLibraryFiles({
          ...library,
          cursors: library?.next_cursor
            ? [undefined, library?.next_cursor]
            : [],
        });
      }
    };
    loadLibrary();
  }, [dispatch, libraryFiles, setLibraryFiles, emailid, email]);

  return (
    <Drawer anchor="left" open={open} onClose={toggle}>
      <Container>
        <Header>
          <h2>Design Library</h2>
          <CloseIconStyle onClick={toggle}></CloseIconStyle>
        </Header>
        {!viewOnly ? (
          <SearchWrapper>
            <SearchBar
              fetchAllOrders={async () => {
                setSearch(undefined);
                const library =
                  selectedTab === 0
                    ? await dispatch(
                        getDesigns({
                          user: email || emailid,
                        })
                      )
                    : await dispatch(
                        getPlusArtFiles({
                          user: email || emailid,
                        })
                      );

                if (library.error) {
                  return;
                }

                populateLibraryData(library);
                const payload = {
                  ...library,
                  cursors: library?.next_cursor
                    ? [undefined, library?.next_cursor]
                    : [],
                };
                if (selectedTab === 0) {
                  setLibraryFiles(payload);
                } else if (selectedTab === 1) {
                  setPlusLibraryFiles(payload);
                }
              }}
              searchById={async (searchString) =>
                searchArtFilesByText(searchString, true)
              }
            />
            <Button
              title="Upload"
              containerStyle={{
                backgroundColor: '#000',
                color: COLORS.WHITE,
                fontWeight: 'normal',
                boxShadow: '4px 4px 20px rgba(0, 0, 0, 0.05)',
                textTransform: 'none',
                borderRadius: '3px',
                fontSize: '12px',
                lineHeight: '1.5',
              }}
              startIcon={<CloudUploadIcon />}
              onClick={() => {
                const myWidget = window.cloudinary.createUploadWidget(
                  {
                    cloudName: 'big-oven-tees-inc',
                    uploadPreset: 'tnedst8q',
                    folder: `BOTApp/${emailid}/ArtFiles`,
                    clientAllowedFormats: ['png', 'pdf'],
                  },
                  (error, result) => {
                    if (!error && result && result.event === 'success') {
                      setLibraryFiles(undefined);
                    }
                  }
                );
                myWidget.open();
              }}
            />
          </SearchWrapper>
        ) : null}

        <div className={classes.root}>
          <AppBar className={classes.header} position="static" color="default">
            <Tabs
              value={selectedTab}
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="primary"
            >
              <Tab label="User Library" />
              <Tab label="TUFF PRINT TRANSFER Art Files" />
              {/* <Tab
                label='Big Oven Tees Designs'
                indicatorColor='primary'
                textColor='primary'
                disabled={orderLine?.dtgPlus || orderLine?.plus || viewOnly}
              />
              <Tab
                label='Big Oven Tees Phrases'
                disabled={orderLine?.dtgPlus || viewOnly}
              /> */}
            </Tabs>
          </AppBar>
          <h3 style={{ color: 'orange' }}>
            Warning: Please make sure that the Artwork you are deleting is not
            used in any "In-Production" order. If artwork is deleted it will
            delay the Production of the order.
          </h3>

          {isGobardownSupport && (
            <Select
              label="Select User Profile"
              options={['support@gobardown.com', 'ben@gobardown.com']}
              value={goBarDownEmail}
              onChange={async (v) => {
                setGoBardownAdmin(v);

                const library = await dispatch(
                  getDesigns({
                    user: v,
                  })
                );
                if (library.error) {
                  return;
                }
                populateLibraryData(library);
                setLibraryFiles({
                  ...library,
                  cursors: library?.next_cursor
                    ? [undefined, library?.next_cursor]
                    : [],
                });
              }}
            />
          )}
          <TabPanel value={selectedTab} index={0}>
            <ArtworksLibrary>
              <div style={{ ...buttonRow, margin: '10px 0' }}>
                <div
                  style={buttonStyles}
                  onClick={async () => {
                    const data = await dispatch(
                      getDesigns({
                        user: isGobardownSupport
                          ? goBarDownEmail
                          : email || emailid,
                        next_cursor:
                          libraryFiles?.cursors[
                            libraryFiles?.cursors?.length - 3
                          ],
                      })
                    );

                    setLibraryFiles({
                      ...data,
                      cursors: libraryFiles?.cursors.slice(
                        0,
                        libraryFiles?.cursors?.length - 1
                      ),
                    });
                  }}
                >
                  {libraryFiles?.cursors?.length > 2 ||
                  (libraryFiles?.cursors?.length === 2 &&
                    !libraryFiles?.next_cursor)
                    ? 'Prev Page'
                    : ''}
                </div>

                <div
                  style={buttonStyles}
                  onClick={async () => {
                    const data = await dispatch(
                      getDesigns({
                        user: isGobardownSupport
                          ? goBarDownEmail
                          : email || emailid,
                        next_cursor:
                          libraryFiles?.cursors[
                            libraryFiles?.cursors?.length - 1
                          ],
                      })
                    );
                    setLibraryFiles({
                      ...data,
                      cursors: data?.next_cursor
                        ? [...libraryFiles?.cursors, data?.next_cursor]
                        : [...libraryFiles?.cursors, undefined],
                    });
                  }}
                >
                  {libraryFiles?.next_cursor ? 'Next Page' : ''}
                </div>
              </div>

              <div>
                {libraryFiles && (
                  <ArtworksLibraryItem
                    libraryFiles={libraryFiles?.resources}
                    onSelect={(artwork) => {
                      onDrop(artwork);
                      if (!viewOnly) {
                        toggle();
                      }
                    }}
                    viewOnly={viewOnly}
                    onDeleteImage={async (publicId) => {
                      const artwork = await dispatch(
                        clearArtWork({
                          user: emailid,
                          publicId,
                        })
                      );
                      if (artwork.error) {
                        return;
                      }

                      setLibraryFiles(undefined);
                    }}
                  />
                )}
              </div>
            </ArtworksLibrary>
          </TabPanel>
          <TabPanel value={selectedTab} index={1}>
            <ArtworksLibrary>
              <div style={{ ...buttonRow, margin: '10px 0' }}>
                <div
                  style={buttonStyles}
                  onClick={async () => {
                    const data = await dispatch(
                      getPlusArtFiles({
                        user: email || emailid,
                        next_cursor:
                          plusLibraryFiles?.cursors[
                            plusLibraryFiles?.cursors?.length - 3
                          ],
                      })
                    );

                    setPlusLibraryFiles({
                      ...data,
                      cursors: plusLibraryFiles?.cursors.slice(
                        0,
                        plusLibraryFiles?.cursors?.length - 1
                      ),
                    });
                  }}
                >
                  {plusLibraryFiles?.cursors?.length > 2 ||
                  (plusLibraryFiles?.cursors?.length === 2 &&
                    !plusLibraryFiles?.next_cursor)
                    ? 'Prev Page'
                    : ''}
                </div>

                <div
                  style={buttonStyles}
                  onClick={async () => {
                    const data = await dispatch(
                      getPlusArtFiles({
                        user: email || emailid,
                        next_cursor:
                          plusLibraryFiles?.cursors[
                            plusLibraryFiles?.cursors?.length - 1
                          ],
                      })
                    );
                    setPlusLibraryFiles({
                      ...data,
                      cursors: data?.next_cursor
                        ? [...plusLibraryFiles?.cursors, data?.next_cursor]
                        : [...plusLibraryFiles?.cursors, undefined],
                    });
                  }}
                >
                  {plusLibraryFiles?.next_cursor ? 'Next Page' : ''}
                </div>
              </div>

              <div>
                {plusLibraryFiles && (
                  <ArtworksLibraryItem
                    libraryFiles={plusLibraryFiles?.resources}
                    onSelect={(artwork) => {
                      onDrop({
                        ...artwork,
                        secure_url: _.endsWith(artwork?.secure_url, 'jpg')
                          ? _.replace(artwork?.secure_url, '.jpg', '.png')
                          : _.replace(artwork?.secure_url, '.jpeg', '.png'),
                      });
                      if (!viewOnly) {
                        toggle();
                      }
                    }}
                    viewOnly={viewOnly}
                    onDeleteImage={async (publicId) => {
                      const artwork = await dispatch(
                        clearArtWork({
                          user: emailid,
                          publicId,
                        })
                      );
                      if (artwork.error) {
                        return;
                      }

                      const library = await dispatch(
                        getPlusArtFiles({
                          user: email || emailid,
                        })
                      );
                      if (library.error) {
                        return;
                      }
                      populateLibraryData(library);
                      setPlusLibraryFiles({
                        ...library,
                        cursors: library?.next_cursor
                          ? [undefined, library?.next_cursor]
                          : [],
                      });
                    }}
                  />
                )}
              </div>
            </ArtworksLibrary>
          </TabPanel>
          <TabPanel value={selectedTab} index={2}>
            <div>
              <h3 style={{ borderBottom: '1px solid #ccc', paddingBottom: 10 }}>
                Select Category&nbsp;-&nbsp;
                <Procedure onClick={() => setProcedureModal(true)}>
                  Take Down Procedure
                </Procedure>
                <ShirtlyCharges>+1$ / design</ShirtlyCharges>
              </h3>
              <Select
                label="Category"
                options={options}
                value={selectedTag || ''}
                onChange={async (tag) => {
                  setTag(tag);
                  const designs = await dispatch(
                    getPreDesigns({
                      tag,
                    })
                  );
                  if (designs?.error) {
                    return;
                  }
                  populateLibraryData(designs);
                  setPreLibraryFiles({
                    ...designs,
                    cursors: designs?.next_cursor
                      ? [undefined, designs?.next_cursor]
                      : [],
                  });
                }}
              />
              <div style={{ ...buttonRow, margin: '10px 0' }}>
                <div
                  style={buttonStyles}
                  onClick={async () => {
                    const data = await dispatch(
                      getPreDesigns({
                        tag: selectedTag,
                        next_cursor:
                          preLibraryFiles?.cursors[
                            preLibraryFiles?.cursors?.length - 3
                          ],
                      })
                    );

                    setPreLibraryFiles({
                      ...data,
                      cursors: preLibraryFiles?.cursors.slice(
                        0,
                        preLibraryFiles?.cursors?.length - 1
                      ),
                    });
                  }}
                >
                  {preLibraryFiles?.cursors?.length > 2 ||
                  (preLibraryFiles?.cursors?.length === 2 &&
                    !preLibraryFiles?.next_cursor)
                    ? 'Prev Page'
                    : ''}
                </div>

                <div
                  style={buttonStyles}
                  onClick={async () => {
                    const data = await dispatch(
                      getPreDesigns({
                        tag: selectedTag,
                        next_cursor:
                          preLibraryFiles?.cursors[
                            preLibraryFiles?.cursors?.length - 1
                          ],
                      })
                    );
                    setPreLibraryFiles({
                      ...data,
                      cursors: data?.next_cursor
                        ? [...preLibraryFiles?.cursors, data?.next_cursor]
                        : [...preLibraryFiles?.cursors, undefined],
                    });
                  }}
                >
                  {preLibraryFiles?.next_cursor ? 'Next Page' : ''}
                </div>
              </div>

              <ArtworksLibrary style={{ maxHeight: '100%' }}>
                <div>
                  {preLibraryFiles && (
                    <ArtworksLibraryItem
                      libraryFiles={preLibraryFiles?.resources}
                      onSelect={(artwork) => {
                        onDrop(artwork);
                        toggle();
                      }}
                    />
                  )}
                </div>
              </ArtworksLibrary>
            </div>
          </TabPanel>
          <TabPanel value={selectedTab} index={3}>
            <h3 style={{ borderBottom: '1px solid #ccc', paddingBottom: 10 }}>
              <Procedure onClick={() => setProcedureModal(true)}>
                Take Down Procedure
              </Procedure>
              <ShirtlyCharges>+1$ / design</ShirtlyCharges>
            </h3>

            <div style={buttonRow}>
              <div
                style={buttonStyles}
                onClick={async () => {
                  const data = await dispatch(
                    getPhraseDesigns(
                      phrasesFiles?.cursors[phrasesFiles?.cursors?.length - 3]
                    )
                  );

                  setPhrasesFiles({
                    ...data,
                    cursors: phrasesFiles?.cursors.slice(
                      0,
                      phrasesFiles?.cursors?.length - 1
                    ),
                  });
                }}
              >
                {phrasesFiles?.cursors?.length > 2 ||
                (phrasesFiles?.cursors?.length === 2 &&
                  !phrasesFiles?.next_cursor)
                  ? 'Prev Page'
                  : ''}
              </div>

              <div
                style={buttonStyles}
                onClick={async () => {
                  const data = await dispatch(
                    getPhraseDesigns(
                      phrasesFiles?.cursors[phrasesFiles?.cursors?.length - 1]
                    )
                  );
                  setPhrasesFiles({
                    ...data,
                    cursors: data?.next_cursor
                      ? [...phrasesFiles?.cursors, data?.next_cursor]
                      : [...phrasesFiles?.cursors, undefined],
                  });
                }}
              >
                {phrasesFiles?.next_cursor ? 'Next Page' : ''}
              </div>
            </div>

            <ArtworksLibrary style={{ maxHeight: '100%' }}>
              <div>
                {phrasesFiles && (
                  <ArtworksLibraryItem
                    libraryFiles={phrasesFiles?.resources}
                    onSelect={(artwork) => {
                      onDrop(artwork);
                      toggle();
                    }}
                  />
                )}
              </div>
            </ArtworksLibrary>
          </TabPanel>
        </div>
      </Container>
      <ProcedureDialog
        open={procedureModal}
        setOpen={(v) => setProcedureModal(v)}
      />
      <ShirtlyPreDesignedDisclaimer
        open={disclaimerModal}
        setOpen={(v) => setDisclaimerModal(v)}
        fetchData={async () => {
          setDisclaimerModal(false);
          setTag(options[0]);
          const designs = await dispatch(
            getPreDesigns({
              tag: options[0],
            })
          );
          if (designs?.error) {
            return;
          }
          populateLibraryData(designs);
          setPreLibraryFiles({
            ...designs,
            cursors: designs?.next_cursor
              ? [undefined, designs?.next_cursor]
              : [],
          });
        }}
      />
    </Drawer>
  );
};

BrowseLibraryDrawer.propTypes = {
  open: PropTypes.bool,
  toggle: PropTypes.func,
};

export default BrowseLibraryDrawer;
